<div
  #player
  class="relative aspect-[4/5] overflow-hidden rounded-3xl bg-ink sm:aspect-[16/9]"
  role="region"
  aria-roledescription="explainer"
  [attr.aria-label]="'How Secure Trade works, scene ' + (index() + 1) + ' of ' + scenes.length"
>
  @for (scene of scenes; track scene.src) {
    <img
      [src]="scene.src"
      [alt]="scene.alt"
      class="explainer-frame absolute inset-0 h-full w-full object-cover"
      [class.is-active]="index() === $index"
      [class.ken-burns]="playing() && index() === $index"
      [attr.aria-hidden]="index() !== $index"
      [attr.loading]="$first ? 'eager' : 'lazy'"
    />
  }

  <div
    class="pointer-events-none absolute inset-0 bg-gradient-to-t from-ink via-ink/45 to-ink/10"
  ></div>
  <div
    class="hero-grain pointer-events-none absolute inset-0 opacity-[0.04] mix-blend-overlay"
  ></div>

  <div class="absolute inset-x-0 bottom-0 p-5 sm:p-8 lg:p-10">
    @let scene = scenes[index()];
    <p class="text-[11px] font-medium uppercase tracking-[0.18em] text-gold">
      {{ scene.kicker }}
    </p>
    <h3
      class="mt-2 max-w-xl font-display text-2xl font-semibold text-cream sm:text-3xl lg:text-4xl"
    >
      {{ scene.title }}
    </h3>
    <p class="mt-2 max-w-lg text-sm leading-relaxed text-cream/75 sm:text-base">
      {{ scene.body }}
    </p>

    <div class="mt-6 flex items-center gap-4">
      <button
        type="button"
        class="flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full border border-cream/30 text-cream transition hover:border-cream hover:bg-cream/10"
        (click)="togglePlayback()"
        [attr.aria-label]="playing() ? 'Pause explainer' : 'Play explainer'"
      >
        <app-icon [name]="playing() ? 'pause' : 'play'" svgClass="h-4 w-4" [strokeWidth]="2" />
      </button>

      <div class="flex min-w-0 flex-1 gap-1.5" role="tablist" aria-label="Explainer scenes">
        @for (s of scenes; track s.src) {
          <button
            type="button"
            class="relative h-1 flex-1 cursor-pointer overflow-hidden rounded-full bg-cream/20"
            (click)="goTo($index)"
            [attr.aria-label]="'Show scene ' + ($index + 1) + ': ' + s.title"
            [attr.aria-current]="index() === $index ? 'true' : null"
          >
            <span
              class="absolute inset-y-0 left-0 rounded-full bg-gold"
              [style.width.%]="segmentWidth($index)"
            ></span>
          </button>
        }
      </div>
    </div>
  </div>
</div>
